import React, { useState } from "react";
import { saveMessageContactForm } from "./../../services/contactformServices"; // Importation de la fonction de sauvegarde
import Button from "./../../components/Button/Button";
import { FaMailBulk } from "react-icons/fa";

const FormContact = () => {
  const [notificationSent, setNotificationSent] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { name, email, message } = formData;
    const notificationMessage = `Formulaire de Contact : ${name}, ${email}, message => ${message}`;

    try {
      // Sauvegarder le message dans la base de données
      await saveMessageContactForm({ name, email, message });

      setNotificationSent(true);
      setFormData({ name: "", email: "", message: "" }); // Réinitialiser le formulaire après l'envoi
    } catch (error) {
      console.error(
        "Erreur lors de l'envoi de la notification ou de la sauvegarde du message",
        error,
      );
    }
  };

  return (
    <section className="py-12 dark:bg-darkBackground text-black dark:text-white">
      <div className="px-4 mx-auto max-w-screen-md">
        <div className="text-center mb-4">
          <h2 className="text-2xl font-bold uppercase relative flex items-center justify-center">
            <span className="flex-1 h-[2px] bg-gray-400"></span>
            <span className="mx-4 text-satoshi">Formulaire de Contact</span>
            <span className="flex-1 h-[2px] bg-gray-400"></span>
          </h2>
        </div>
        <p className="font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl font-satoshi">
          Vous avez des questions ou des commentaires sur l'application ?
        </p>
        <p className="mb-2 lg:mb-16 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl font-satoshi">
          N'hésitez pas à nous contacter.
        </p>
        <p className="mb-8 lg:mb-16 text-normal font-semibold text-center text-gray-500 dark:text-gray-400 font-satoshi italic">
          Si votre question concerne la Ligue Nouvelle Aquitaine, merci de le
          faire par mail au{" "}
          <a
            href="mailto:secretariat.limoges@nouvelleaquitaine-ffjudo.com"
            className="text-blue-500"
          >
            secretariat.limoges@nouvelleaquitaine-ffjudo.com
          </a>
          .
        </p>
        <form className="space-y-8" onSubmit={handleSubmit}>
          <div>
            <label
              htmlFor="email"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300 font-satoshi"
            >
              Votre email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light font-satoshi"
              placeholder="mail@gmail.com"
              required
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300 font-satoshi"
            >
              Nom Prénom
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light font-satoshi"
              placeholder="Votre Nom Prénom"
              required
              value={formData.name}
              onChange={handleInputChange}
            />
          </div>
          <div className="sm:col-span-2">
            <label
              htmlFor="message"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400 font-satoshi"
            >
              Votre Message
            </label>
            <textarea
              id="message"
              name="message"
              rows="6"
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 font-satoshi"
              placeholder="Laissez votre message ici..."
              value={formData.message}
              onChange={handleInputChange}
            ></textarea>
          </div>
          <div className="flex items-center justify-center gap-2">
            <Button
              text="Envoyer"
              icon={FaMailBulk}
              hoverLabel="Envoyer le message"
              type="submit"
              className="gap-2"
            />
          </div>
          {notificationSent && (
            <p className="text-blue-500 text-center">
              Votre message a bien été envoyé!
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default FormContact;
